const JobActionTypes = {
  LOAD_JOBS:      'LOAD_JOBS',
  LOAD_JOBS_DONE: 'LOAD_JOBS_DONE',
  LOAD_JOBS_FAIL: 'LOAD_JOBS_FAIL',

  LOAD_JOB:      'LOAD_JOB',
  LOAD_JOB_DONE: 'LOAD_JOB_DONE',
  LOAD_JOB_FAIL: 'LOAD_JOB_FAIL',

  CREATE_JOB:      'CREATE_JOB',
  CREATE_JOB_DONE: 'CREATE_JOB_DONE',
  CREATE_JOB_FAIL: 'CREATE_JOB_FAIL',

  UPDATE_JOB:      'UPDATE_JOB',
  UPDATE_JOB_DONE: 'UPDATE_JOB_DONE',
  UPDATE_JOB_FAIL: 'UPDATE_JOB_FAIL',

  DELETE_JOB:      'DELETE_JOB',
  DELETE_JOB_DONE: 'DELETE_JOB_DONE',
  DELETE_JOB_FAIL: 'DELETE_JOB_FAIL',

  CLONE_JOB:      'CLONE_JOB',
  CLONE_JOB_DONE: 'CLONE_JOB_DONE',
  CLONE_JOB_FAIL: 'CLONE_JOB_FAIL',

  BULK_UPDATE_JOBS:      'BULK_UPDATE_JOBS',
  BULK_UPDATE_JOBS_DONE: 'BULK_UPDATE_JOBS_DONE',
  BULK_UPDATE_JOBS_FAIL: 'BULK_UPDATE_JOBS_FAIL',

  BULK_DELETE_JOBS:      'BULK_DELETE_JOBS',
  BULK_DELETE_JOBS_DONE: 'BULK_DELETE_JOBS_DONE',
  BULK_DELETE_JOBS_FAIL: 'BULK_DELETE_JOBS_FAIL',

  LOAD_JOB_FORM_DROPDOWNS:      'LOAD_JOB_FORM_DROPDOWNS',
  LOAD_JOB_FORM_DROPDOWNS_DONE: 'LOAD_JOB_FORM_DROPDOWNS_DONE',
  LOAD_JOB_FORM_DROPDOWNS_FAIL: 'LOAD_JOB_FORM_DROPDOWNS_FAIL',

  SWITCH_JOB_SCOPE_SIZE:       'SWITCH_JOB_SCOPE_SIZE',
  SWITCH_CANDIDATE_SCOPE_SIZE: 'SWITCH_CANDIDATE_SCOPE_SIZE',

  LOAD_CANDIDATES:      'LOAD_CANDIDATES',
  LOAD_CANDIDATES_DONE: 'LOAD_CANDIDATES_DONE',
  LOAD_CANDIDATES_FAIL: 'LOAD_CANDIDATES_FAIL',

  LOAD_LEAD_JOB_APPLICATIONS:      'LOAD_LEAD_JOB_APPLICATIONS',
  LOAD_LEAD_JOB_APPLICATIONS_DONE: 'LOAD_LEAD_JOB_APPLICATIONS_DONE',
  LOAD_LEAD_JOB_APPLICATIONS_FAIL: 'LOAD_LEAD_JOB_APPLICATIONS_FAIL',


  BULK_REMOVE_CANDIDATES_FROM_JOB:      'BULK_REMOVE_CANDIDATES_FROM_JOB',
  BULK_REMOVE_CANDIDATES_FROM_JOB_DONE: 'BULK_REMOVE_CANDIDATES_FROM_JOB_DONE',
  BULK_REMOVE_CANDIDATES_FROM_JOB_FAIL: 'BULK_REMOVE_CANDIDATES_FROM_JOB_FAIL',

  BULK_UPDATE_CANDIDATES_FROM_JOB:      'BULK_UPDATE_CANDIDATES_FROM_JOB',
  BULK_UPDATE_CANDIDATES_FROM_JOB_DONE: 'BULK_UPDATE_CANDIDATES_FROM_JOB_DONE',
  BULK_UPDATE_CANDIDATES_FROM_JOB_FAIL: 'BULK_UPDATE_CANDIDATES_FROM_JOB_FAIL',
};

export default JobActionTypes;
